import { css } from '@/styled-system/css';

// Form container
export const dateTimeForm = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '20px',
});

// Header styles
export const header = css({
  fontSize: 'xl',
  fontWeight: 'bold',
  alignSelf: 'flex-start',
  paddingBottom: '15px',
});

export const subheader = css({
  fontSize: 'md',
  alignSelf: 'flex-start',
  paddingBottom: '10px',
});

// Date carousel container
export const dateCarouselContainer = css({
  display: 'flex',
  gap: '5px',
  justifyContent: 'flex-start',
  alignItems: 'stretch',
});

// Carousel arrow buttons
export const carouselArrowButton = css({
  _hover: {
    cursor: 'pointer',
  },
});

export const carouselArrowButtonDisabled = css({
  visibility: 'hidden',
  _hover: {
    cursor: 'default',
  },
});

// Date buttons
export const dateButton = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '10px',
  padding: '10px',
  bg: 'hpxWhite',
  boxSizing: 'border-box',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  borderRadius: '4px',
  height: '104px',
  width: '90px',
  md: {
    width: '104px',
  },
  _hover: {
    cursor: 'pointer',
  },
});

export const dateButtonPressed = css({
  bg: 'hpxTeal100',
});

export const dateButtonDisabled = css({
  bg: 'hpxGrey400',
  _hover: {
    cursor: 'default',
  },
});

// Time buttons container (base - dynamic columns via inline style)
export const timeButtonsContainer = css({
  display: 'grid',
  columnGap: '5px',
  rowGap: '10px',
});

// Time buttons
export const timeButton = css({
  width: '90px',
  md: {
    width: '104px',
  },
  padding: '5px',
  bg: 'hpxWhite',
  boxSizing: 'border-box',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  borderRadius: '4px',
  _hover: {
    cursor: 'pointer',
  },
});

export const timeButtonPressed = css({
  bg: 'hpxTeal100',
});

export const timeButtonDisabled = css({
  bg: 'hpxGrey400',
});

// Button text styles (replaces styled Text component)
export const buttonText = css({
  fontWeight: 'bold',
  fontSize: 'md',
});

export const buttonTextLg = css({
  fontWeight: 'bold',
  fontSize: 'lg',
});
